import React from 'react';
import { Link } from 'react-router-dom';

export default function ModuleCard({ id, name, status, to }) {
  const isReady = status === 'ready';
  const link = to || `/module/${id}`;

  return (
    <Link to={link} className="block group">
      <div className="flex items-center justify-between py-5 border-b border-white/8 active:bg-white/3 transition-colors duration-150 cursor-pointer select-none px-1">

        {/* Left: number + name */}
        <div className="flex items-center gap-4">
          <span className="text-xs font-light w-5 text-right shrink-0" style={{ color: 'var(--gold)' }}>
            {id}
          </span>
          <span className="text-sm font-medium tracking-[0.18em] uppercase text-white group-active:text-gray-300 transition-colors">
            {name}
          </span>
        </div>

        {/* Right: status dot + arrow */}
        <div className="flex items-center gap-3 shrink-0">
          <span className={`w-1.5 h-1.5 rounded-full ${
            isReady ? 'bg-green-400' : status === 'running' ? 'bg-yellow-400 animate-pulse' : 'bg-gray-600'
          }`} />
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ color: 'var(--gold)' }}>
            <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    </Link>
  );
}
